{
  "en": {
    "· всё входит": "· everything included",
    "{0} · {1} из {2}": "{0} · {1} of {2}",
    "{0} · кадр {1} из {2}": "{0} · frame {1} of {2}",
    "{0} · пример · {1} из {2}": "{0} · example · {1} of {2}",
    "{0} в {1}": "{0} in {1}",
    "{0}: кадры образа": "{0}: frames of the look",
    "{0}: пример крупно": "{0}: example, enlarged",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. The bot will send them to the chat, in a separate topic.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. The bot has already sent them to the chat, in a separate topic.",
    "Все образы": "All looks",
    "Все образы, {0}": "All looks, {0}",
    "выберите образ": "choose a look",
    "Выберите хотя бы один образ": "Choose at least one look",
    "Выбранные · {0}": "Selected · {0}",
    "Выбрать образ": "Choose a look",
    "Готово · {0} · {1}": "Done · {0} · {1}",
    "Ещё образ": "One more look",
    "за кадр": "per frame",
    "Загружаем образы…": "Loading looks…",
    "Изменить настройки": "Change settings",
    "Искать среди {0} образов": "Search {0} looks",
    "кадр": "frame",
    "Кадр {0}": "Frame {0}",
    "кадр {0} из {1}": "frame {0} of {1}",
    "кадра": "frames",
    "кадров": "frames",
    "Кадры": "Frames",
    "Кадры ещё загружаются": "Frames are still loading",
    "Кадры фотосессии": "Photo shoot frames",
    "Как будет выглядеть": "How it will look",
    "Модерация после списания": "Moderation after the charge",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "You can leave the screen: the bot will send the photos to the chat as they are ready.",
    "Нажмите, чтобы выбрать образ": "Tap to choose a look",
    "Например: нарядная одежда, без очков": "For example: festive clothes, no glasses",
    "Не получилось снять фотосессию": "Could not create the photo shoot",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Could not pass the frame on. Open the work in “History” and try again.",
    "образ": "look",
    "образа": "looks",
    "образах": "looks",
    "образе": "look",
    "образов": "looks",
    "Образы": "Looks",
    "Образы сняты": "Looks shot",
    "Поиск образов": "Look search",
    "Полароид-рилс": "Polaroid reel",
    "Предыдущий": "Previous",
    "Пример кадра · {0} из {1}": "Example frame · {0} of {1}",
    "Скачать все": "Download all",
    "Следующий": "Next",
    "Смотреть все кадры": "View all frames",
    "Смотреть кадры: {0}": "View frames: {0}",
    "Снимаем образы": "Shooting the looks",
    "Создаём фотосессию": "Creating the photo shoot",
    "Создать {0} · {1} C": "Create {0} · {1} C",
    "Создать фотосессию": "Create a photo shoot",
    "Удерживайте, чтобы посмотреть кадры": "Hold to view the frames",
    "фото не созданы": "the photos were not created",
    "Фото проверены": "Photos checked",
    "Фотосессия готова": "The photo shoot is ready",
    "Фотосессия не прошла проверку": "The photo shoot did not pass the check",
    "Добавьте в кадр себя, близкого или персонажа": "Add yourself, someone close or a character to the frame"
  },
  "hy": {
    "· всё входит": "· ամեն ինչ ներառված է",
    "{0} · {1} из {2}": "{0} · {1}՝ {2}-ից",
    "{0} · кадр {1} из {2}": "{0} · կադր {1}՝ {2}-ից",
    "{0} · пример · {1} из {2}": "{0} · օրինակ · {1}՝ {2}-ից",
    "{0} в {1}": "{0} {1}",
    "{0}: кадры образа": "{0}՝ կերպարի կադրերը",
    "{0}: пример крупно": "{0}՝ օրինակը խոշոր",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}։ Բոտը դրանք կուղարկի չատ՝ առանձին թեմայում։",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}։ Բոտն արդեն ուղարկել է դրանք չատ՝ առանձին թեմայում։",
    "Все образы": "Բոլոր կերպարները",
    "Все образы, {0}": "Բոլոր կերպարները, {0}",
    "выберите образ": "ընտրեք կերպար",
    "Выберите хотя бы один образ": "Ընտրեք առնվազն մեկ կերպար",
    "Выбранные · {0}": "Ընտրվածները · {0}",
    "Выбрать образ": "Ընտրել կերպար",
    "Готово · {0} · {1}": "Պատրաստ է · {0} · {1}",
    "Ещё образ": "Եվս մեկ կերպար",
    "за кадр": "մեկ կադրի համար",
    "Загружаем образы…": "Բեռնում ենք կերպարները…",
    "Изменить настройки": "Փոխել կարգավորումները",
    "Искать среди {0} образов": "Որոնել {0} կերպարների մեջ",
    "кадр": "կադր",
    "Кадр {0}": "Կադր {0}",
    "кадр {0} из {1}": "կադր {0}՝ {1}-ից",
    "кадра": "կադր",
    "кадров": "կադր",
    "Кадры": "Կադրեր",
    "Кадры ещё загружаются": "Կադրերը դեռ բեռնվում են",
    "Кадры фотосессии": "Ֆոտոսեսիայի կադրերը",
    "Как будет выглядеть": "Ինչ տեսք կունենա",
    "Модерация после списания": "Մոդերացիա՝ գանձումից հետո",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Կարող եք դուրս գալ էկրանից. բոտը լուսանկարները կուղարկի չատ՝ պատրաստ լինելուն պես։",
    "Нажмите, чтобы выбрать образ": "Սեղմեք՝ կերպար ընտրելու համար",
    "Например: нарядная одежда, без очков": "Օրինակ՝ տոնական հագուստ, առանց ակնոցի",
    "Не получилось снять фотосессию": "Չհաջողվեց ստեղծել ֆոտոսեսիան",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Չհաջողվեց փոխանցել կադրը։ Բացեք աշխատանքը «Պատմություն»-ում և նորից փորձեք։",
    "образ": "կերպար",
    "образа": "կերպար",
    "образах": "կերպարում",
    "образе": "կերպարում",
    "образов": "կերպար",
    "Образы": "Կերպարներ",
    "Образы сняты": "Կերպարները նկարված են",
    "Поиск образов": "Կերպարների որոնում",
    "Полароид-рилс": "Պոլարոիդ ռիլս",
    "Предыдущий": "Նախորդը",
    "Пример кадра · {0} из {1}": "Կադրի օրինակ · {0}՝ {1}-ից",
    "Скачать все": "Ներբեռնել բոլորը",
    "Следующий": "Հաջորդը",
    "Смотреть все кадры": "Դիտել բոլոր կադրերը",
    "Смотреть кадры: {0}": "Դիտել կադրերը՝ {0}",
    "Снимаем образы": "Նկարում ենք կերպարները",
    "Создаём фотосессию": "Ստեղծում ենք ֆոտոսեսիան",
    "Создать {0} · {1} C": "Ստեղծել {0} · {1} C",
    "Создать фотосессию": "Ստեղծել ֆոտոսեսիա",
    "Удерживайте, чтобы посмотреть кадры": "Պահեք՝ կադրերը դիտելու համար",
    "фото не созданы": "լուսանկարները չեն ստեղծվել",
    "Фото проверены": "Լուսանկարները ստուգված են",
    "Фотосессия готова": "Ֆոտոսեսիան պատրաստ է",
    "Фотосессия не прошла проверку": "Ֆոտոսեսիան չի անցել ստուգումը",
    "Добавьте в кадр себя, близкого или персонажа": "Կադրում ավելացրեք ինքներդ ձեզ, մտերիմին կամ կերպարին"
  },
  "es": {
    "· всё входит": "· todo incluido",
    "{0} · {1} из {2}": "{0} · {1} de {2}",
    "{0} · кадр {1} из {2}": "{0} · toma {1} de {2}",
    "{0} · пример · {1} из {2}": "{0} · ejemplo · {1} de {2}",
    "{0} в {1}": "{0} en {1}",
    "{0}: кадры образа": "{0}: tomas del look",
    "{0}: пример крупно": "{0}: ejemplo ampliado",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. El bot las enviará al chat, en un tema aparte.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. El bot ya las envió al chat, en un tema aparte.",
    "Все образы": "Todos los looks",
    "Все образы, {0}": "Todos los looks, {0}",
    "выберите образ": "elige un look",
    "Выберите хотя бы один образ": "Elige al menos un look",
    "Выбранные · {0}": "Elegidos · {0}",
    "Выбрать образ": "Elegir un look",
    "Готово · {0} · {1}": "Hecho · {0} · {1}",
    "Ещё образ": "Otro look",
    "за кадр": "por toma",
    "Загружаем образы…": "Cargando looks…",
    "Изменить настройки": "Cambiar ajustes",
    "Искать среди {0} образов": "Buscar entre {0} looks",
    "кадр": "toma",
    "Кадр {0}": "Toma {0}",
    "кадр {0} из {1}": "toma {0} de {1}",
    "кадра": "tomas",
    "кадров": "tomas",
    "Кадры": "Tomas",
    "Кадры ещё загружаются": "Las tomas aún se están cargando",
    "Кадры фотосессии": "Tomas de la sesión",
    "Как будет выглядеть": "Cómo se verá",
    "Модерация после списания": "Moderación después del cargo",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Puedes salir de la pantalla: el bot enviará las fotos al chat a medida que estén listas.",
    "Нажмите, чтобы выбрать образ": "Toca para elegir un look",
    "Например: нарядная одежда, без очков": "Por ejemplo: ropa elegante, sin gafas",
    "Не получилось снять фотосессию": "No se pudo crear la sesión de fotos",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "No se pudo pasar la toma. Abre el trabajo en «Historial» e inténtalo de nuevo.",
    "образ": "look",
    "образа": "looks",
    "образах": "looks",
    "образе": "look",
    "образов": "looks",
    "Образы": "Looks",
    "Образы сняты": "Looks fotografiados",
    "Поиск образов": "Búsqueda de looks",
    "Полароид-рилс": "Reel Polaroid",
    "Предыдущий": "Anterior",
    "Пример кадра · {0} из {1}": "Toma de ejemplo · {0} de {1}",
    "Скачать все": "Descargar todo",
    "Следующий": "Siguiente",
    "Смотреть все кадры": "Ver todas las tomas",
    "Смотреть кадры: {0}": "Ver tomas: {0}",
    "Снимаем образы": "Fotografiando los looks",
    "Создаём фотосессию": "Creando la sesión de fotos",
    "Создать {0} · {1} C": "Crear {0} · {1} C",
    "Создать фотосессию": "Crear una sesión de fotos",
    "Удерживайте, чтобы посмотреть кадры": "Mantén pulsado para ver las tomas",
    "фото не созданы": "las fotos no se crearon",
    "Фото проверены": "Fotos revisadas",
    "Фотосессия готова": "La sesión de fotos está lista",
    "Фотосессия не прошла проверку": "La sesión de fotos no superó la revisión",
    "Добавьте в кадр себя, близкого или персонажа": "Añade al encuadre a ti, a alguien cercano o a un personaje"
  },
  "de": {
    "· всё входит": "· alles inklusive",
    "{0} · {1} из {2}": "{0} · {1} von {2}",
    "{0} · кадр {1} из {2}": "{0} · Bild {1} von {2}",
    "{0} · пример · {1} из {2}": "{0} · Beispiel · {1} von {2}",
    "{0} в {1}": "{0} in {1}",
    "{0}: кадры образа": "{0}: Bilder des Looks",
    "{0}: пример крупно": "{0}: Beispiel groß",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. Der Bot schickt sie in den Chat, in ein eigenes Thema.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. Der Bot hat sie bereits in den Chat geschickt, in ein eigenes Thema.",
    "Все образы": "Alle Looks",
    "Все образы, {0}": "Alle Looks, {0}",
    "выберите образ": "Look wählen",
    "Выберите хотя бы один образ": "Wählen Sie mindestens einen Look",
    "Выбранные · {0}": "Ausgewählt · {0}",
    "Выбрать образ": "Look wählen",
    "Готово · {0} · {1}": "Fertig · {0} · {1}",
    "Ещё образ": "Weiterer Look",
    "за кадр": "pro Bild",
    "Загружаем образы…": "Looks werden geladen…",
    "Изменить настройки": "Einstellungen ändern",
    "Искать среди {0} образов": "In {0} Looks suchen",
    "кадр": "Bild",
    "Кадр {0}": "Bild {0}",
    "кадр {0} из {1}": "Bild {0} von {1}",
    "кадра": "Bilder",
    "кадров": "Bilder",
    "Кадры": "Bilder",
    "Кадры ещё загружаются": "Die Bilder werden noch geladen",
    "Кадры фотосессии": "Bilder des Fotoshootings",
    "Как будет выглядеть": "So wird es aussehen",
    "Модерация после списания": "Moderation nach der Abbuchung",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Sie können den Bildschirm verlassen: Der Bot schickt die Fotos in den Chat, sobald sie fertig sind.",
    "Нажмите, чтобы выбрать образ": "Tippen Sie, um einen Look zu wählen",
    "Например: нарядная одежда, без очков": "Zum Beispiel: festliche Kleidung, ohne Brille",
    "Не получилось снять фотосессию": "Das Fotoshooting konnte nicht erstellt werden",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Das Bild konnte nicht übergeben werden. Öffnen Sie die Arbeit im „Verlauf“ und versuchen Sie es erneut.",
    "образ": "Look",
    "образа": "Looks",
    "образах": "Looks",
    "образе": "Look",
    "образов": "Looks",
    "Образы": "Looks",
    "Образы сняты": "Looks fotografiert",
    "Поиск образов": "Look-Suche",
    "Полароид-рилс": "Polaroid-Reel",
    "Предыдущий": "Vorheriges",
    "Пример кадра · {0} из {1}": "Beispielbild · {0} von {1}",
    "Скачать все": "Alle herunterladen",
    "Следующий": "Nächstes",
    "Смотреть все кадры": "Alle Bilder ansehen",
    "Смотреть кадры: {0}": "Bilder ansehen: {0}",
    "Снимаем образы": "Looks werden fotografiert",
    "Создаём фотосессию": "Fotoshooting wird erstellt",
    "Создать {0} · {1} C": "{0} erstellen · {1} C",
    "Создать фотосессию": "Fotoshooting erstellen",
    "Удерживайте, чтобы посмотреть кадры": "Gedrückt halten, um die Bilder anzusehen",
    "фото не созданы": "die Fotos wurden nicht erstellt",
    "Фото проверены": "Fotos geprüft",
    "Фотосессия готова": "Das Fotoshooting ist fertig",
    "Фотосессия не прошла проверку": "Das Fotoshooting hat die Prüfung nicht bestanden",
    "Добавьте в кадр себя, близкого или персонажа": "Füge dich selbst, eine nahestehende Person oder eine Figur hinzu"
  },
  "fr": {
    "· всё входит": "· tout est inclus",
    "{0} · {1} из {2}": "{0} · {1} sur {2}",
    "{0} · кадр {1} из {2}": "{0} · prise {1} sur {2}",
    "{0} · пример · {1} из {2}": "{0} · exemple · {1} sur {2}",
    "{0} в {1}": "{0} en {1}",
    "{0}: кадры образа": "{0} : prises du look",
    "{0}: пример крупно": "{0} : exemple agrandi",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. Le bot les enverra dans le chat, dans un sujet à part.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. Le bot les a déjà envoyées dans le chat, dans un sujet à part.",
    "Все образы": "Tous les looks",
    "Все образы, {0}": "Tous les looks, {0}",
    "выберите образ": "choisissez un look",
    "Выберите хотя бы один образ": "Choisissez au moins un look",
    "Выбранные · {0}": "Choisis · {0}",
    "Выбрать образ": "Choisir un look",
    "Готово · {0} · {1}": "Terminé · {0} · {1}",
    "Ещё образ": "Un autre look",
    "за кадр": "par prise",
    "Загружаем образы…": "Chargement des looks…",
    "Изменить настройки": "Modifier les réglages",
    "Искать среди {0} образов": "Rechercher parmi {0} looks",
    "кадр": "prise",
    "Кадр {0}": "Prise {0}",
    "кадр {0} из {1}": "prise {0} sur {1}",
    "кадра": "prises",
    "кадров": "prises",
    "Кадры": "Prises",
    "Кадры ещё загружаются": "Les prises sont encore en cours de chargement",
    "Кадры фотосессии": "Prises de la séance",
    "Как будет выглядеть": "À quoi ça ressemblera",
    "Модерация после списания": "Modération après le débit",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Vous pouvez quitter l’écran : le bot enverra les photos dans le chat au fur et à mesure.",
    "Нажмите, чтобы выбрать образ": "Touchez pour choisir un look",
    "Например: нарядная одежда, без очков": "Par exemple : tenue de fête, sans lunettes",
    "Не получилось снять фотосессию": "Impossible de créer la séance photo",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Impossible de transmettre la prise. Ouvrez le travail dans « Historique » et réessayez.",
    "образ": "look",
    "образа": "looks",
    "образах": "looks",
    "образе": "look",
    "образов": "looks",
    "Образы": "Looks",
    "Образы сняты": "Looks photographiés",
    "Поиск образов": "Recherche de looks",
    "Полароид-рилс": "Reel Polaroid",
    "Предыдущий": "Précédent",
    "Пример кадра · {0} из {1}": "Prise d’exemple · {0} sur {1}",
    "Скачать все": "Tout télécharger",
    "Следующий": "Suivant",
    "Смотреть все кадры": "Voir toutes les prises",
    "Смотреть кадры: {0}": "Voir les prises : {0}",
    "Снимаем образы": "Prise de vue des looks",
    "Создаём фотосессию": "Création de la séance photo",
    "Создать {0} · {1} C": "Créer {0} · {1} C",
    "Создать фотосессию": "Créer une séance photo",
    "Удерживайте, чтобы посмотреть кадры": "Maintenez pour voir les prises",
    "фото не созданы": "les photos n’ont pas été créées",
    "Фото проверены": "Photos vérifiées",
    "Фотосессия готова": "La séance photo est prête",
    "Фотосессия не прошла проверку": "La séance photo n’a pas passé la vérification",
    "Добавьте в кадр себя, близкого или персонажа": "Ajoutez-vous, un proche ou un personnage au cadre"
  },
  "pt": {
    "· всё входит": "· tudo incluído",
    "{0} · {1} из {2}": "{0} · {1} de {2}",
    "{0} · кадр {1} из {2}": "{0} · foto {1} de {2}",
    "{0} · пример · {1} из {2}": "{0} · exemplo · {1} de {2}",
    "{0} в {1}": "{0} em {1}",
    "{0}: кадры образа": "{0}: fotos do look",
    "{0}: пример крупно": "{0}: exemplo ampliado",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. O bot vai enviá-las para o chat, num tópico separado.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. O bot já as enviou para o chat, num tópico separado.",
    "Все образы": "Todos os looks",
    "Все образы, {0}": "Todos os looks, {0}",
    "выберите образ": "escolha um look",
    "Выберите хотя бы один образ": "Escolha pelo menos um look",
    "Выбранные · {0}": "Escolhidos · {0}",
    "Выбрать образ": "Escolher um look",
    "Готово · {0} · {1}": "Concluído · {0} · {1}",
    "Ещё образ": "Mais um look",
    "за кадр": "por foto",
    "Загружаем образы…": "Carregando looks…",
    "Изменить настройки": "Alterar configurações",
    "Искать среди {0} образов": "Pesquisar entre {0} looks",
    "кадр": "foto",
    "Кадр {0}": "Foto {0}",
    "кадр {0} из {1}": "foto {0} de {1}",
    "кадра": "fotos",
    "кадров": "fotos",
    "Кадры": "Fotos",
    "Кадры ещё загружаются": "As fotos ainda estão carregando",
    "Кадры фотосессии": "Fotos da sessão",
    "Как будет выглядеть": "Como vai ficar",
    "Модерация после списания": "Moderação após a cobrança",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Pode sair da tela: o bot enviará as fotos para o chat à medida que ficarem prontas.",
    "Нажмите, чтобы выбрать образ": "Toque para escolher um look",
    "Например: нарядная одежда, без очков": "Por exemplo: roupa de festa, sem óculos",
    "Не получилось снять фотосессию": "Não foi possível criar a sessão de fotos",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Não foi possível passar a foto. Abra o trabalho no «Histórico» e tente novamente.",
    "образ": "look",
    "образа": "looks",
    "образах": "looks",
    "образе": "look",
    "образов": "looks",
    "Образы": "Looks",
    "Образы сняты": "Looks fotografados",
    "Поиск образов": "Pesquisa de looks",
    "Полароид-рилс": "Reel Polaroid",
    "Предыдущий": "Anterior",
    "Пример кадра · {0} из {1}": "Foto de exemplo · {0} de {1}",
    "Скачать все": "Baixar tudo",
    "Следующий": "Seguinte",
    "Смотреть все кадры": "Ver todas as fotos",
    "Смотреть кадры: {0}": "Ver fotos: {0}",
    "Снимаем образы": "Fotografando os looks",
    "Создаём фотосессию": "Criando a sessão de fotos",
    "Создать {0} · {1} C": "Criar {0} · {1} C",
    "Создать фотосессию": "Criar uma sessão de fotos",
    "Удерживайте, чтобы посмотреть кадры": "Mantenha pressionado para ver as fotos",
    "фото не созданы": "as fotos não foram criadas",
    "Фото проверены": "Fotos verificadas",
    "Фотосессия готова": "A sessão de fotos está pronta",
    "Фотосессия не прошла проверку": "A sessão de fotos não passou na verificação",
    "Добавьте в кадр себя, близкого или персонажа": "Adicione você, alguém próximo ou um personagem ao quadro"
  },
  "tr": {
    "· всё входит": "· hepsi dahil",
    "{0} · {1} из {2}": "{0} · {2} içinden {1}",
    "{0} · кадр {1} из {2}": "{0} · {2} içinden {1}. kare",
    "{0} · пример · {1} из {2}": "{0} · örnek · {2} içinden {1}",
    "{0} в {1}": "{1} {0}",
    "{0}: кадры образа": "{0}: tarzın kareleri",
    "{0}: пример крупно": "{0}: büyük örnek",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. Bot bunları sohbete, ayrı bir konuya gönderecek.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. Bot bunları zaten sohbete, ayrı bir konuya gönderdi.",
    "Все образы": "Tüm tarzlar",
    "Все образы, {0}": "Tüm tarzlar, {0}",
    "выберите образ": "bir tarz seçin",
    "Выберите хотя бы один образ": "En az bir tarz seçin",
    "Выбранные · {0}": "Seçilenler · {0}",
    "Выбрать образ": "Tarz seç",
    "Готово · {0} · {1}": "Tamamlandı · {0} · {1}",
    "Ещё образ": "Bir tarz daha",
    "за кадр": "kare başına",
    "Загружаем образы…": "Tarzlar yükleniyor…",
    "Изменить настройки": "Ayarları değiştir",
    "Искать среди {0} образов": "{0} tarz içinde ara",
    "кадр": "kare",
    "Кадр {0}": "Kare {0}",
    "кадр {0} из {1}": "{1} içinden {0}. kare",
    "кадра": "kare",
    "кадров": "kare",
    "Кадры": "Kareler",
    "Кадры ещё загружаются": "Kareler hâlâ yükleniyor",
    "Кадры фотосессии": "Çekimin kareleri",
    "Как будет выглядеть": "Nasıl görünecek",
    "Модерация после списания": "Ödeme sonrasında moderasyon",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Ekrandan çıkabilirsiniz: bot fotoğrafları hazır oldukça sohbete gönderecek.",
    "Нажмите, чтобы выбрать образ": "Tarz seçmek için dokunun",
    "Например: нарядная одежда, без очков": "Örneğin: şık kıyafetler, gözlüksüz",
    "Не получилось снять фотосессию": "Fotoğraf çekimi oluşturulamadı",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Kare aktarılamadı. Çalışmayı «Geçmiş» bölümünde açıp yeniden deneyin.",
    "образ": "tarz",
    "образа": "tarz",
    "образах": "tarzda",
    "образе": "tarzda",
    "образов": "tarz",
    "Образы": "Tarzlar",
    "Образы сняты": "Tarzlar çekildi",
    "Поиск образов": "Tarz arama",
    "Полароид-рилс": "Polaroid reels",
    "Предыдущий": "Önceki",
    "Пример кадра · {0} из {1}": "Örnek kare · {1} içinden {0}",
    "Скачать все": "Tümünü indir",
    "Следующий": "Sonraki",
    "Смотреть все кадры": "Tüm kareleri görüntüle",
    "Смотреть кадры: {0}": "Kareleri görüntüle: {0}",
    "Снимаем образы": "Tarzlar çekiliyor",
    "Создаём фотосессию": "Fotoğraf çekimi oluşturuluyor",
    "Создать {0} · {1} C": "{0} oluştur · {1} C",
    "Создать фотосессию": "Fotoğraf çekimi oluştur",
    "Удерживайте, чтобы посмотреть кадры": "Kareleri görmek için basılı tutun",
    "фото не созданы": "fotoğraflar oluşturulmadı",
    "Фото проверены": "Fotoğraflar kontrol edildi",
    "Фотосессия готова": "Fotoğraf çekimi hazır",
    "Фотосессия не прошла проверку": "Fotoğraf çekimi kontrolden geçmedi",
    "Добавьте в кадр себя, близкого или персонажа": "Kadraja kendinizi, bir yakınınızı veya bir karakter ekleyin"
  },
  "kk": {
    "· всё входит": "· бәрі кіреді",
    "{0} · {1} из {2}": "{0} · {2} ішінен {1}",
    "{0} · кадр {1} из {2}": "{0} · {2} ішінен {1}-кадр",
    "{0} · пример · {1} из {2}": "{0} · мысал · {2} ішінен {1}",
    "{0} в {1}": "{1} {0}",
    "{0}: кадры образа": "{0}: образ кадрлары",
    "{0}: пример крупно": "{0}: мысалды үлкейтіп",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. Бот оларды чатқа жеке тақырыпқа жібереді.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. Бот оларды чатқа жеке тақырыпқа жіберіп қойды.",
    "Все образы": "Барлық образдар",
    "Все образы, {0}": "Барлық образдар, {0}",
    "выберите образ": "образ таңдаңыз",
    "Выберите хотя бы один образ": "Кемінде бір образ таңдаңыз",
    "Выбранные · {0}": "Таңдалғандар · {0}",
    "Выбрать образ": "Образ таңдау",
    "Готово · {0} · {1}": "Дайын · {0} · {1}",
    "Ещё образ": "Тағы бір образ",
    "за кадр": "бір кадр үшін",
    "Загружаем образы…": "Образдар жүктелуде…",
    "Изменить настройки": "Баптауларды өзгерту",
    "Искать среди {0} образов": "{0} образ арасынан іздеу",
    "кадр": "кадр",
    "Кадр {0}": "{0}-кадр",
    "кадр {0} из {1}": "{1} ішінен {0}-кадр",
    "кадра": "кадр",
    "кадров": "кадр",
    "Кадры": "Кадрлар",
    "Кадры ещё загружаются": "Кадрлар әлі жүктелуде",
    "Кадры фотосессии": "Фотосессия кадрлары",
    "Как будет выглядеть": "Қалай көрінеді",
    "Модерация после списания": "Есептен шығарғаннан кейін модерация",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Экраннан шыға беруге болады: бот фотосуреттерді дайын болған сайын чатқа жібереді.",
    "Нажмите, чтобы выбрать образ": "Образ таңдау үшін басыңыз",
    "Например: нарядная одежда, без очков": "Мысалы: сәнді киім, көзілдіріксіз",
    "Не получилось снять фотосессию": "Фотосессияны жасау мүмкін болмады",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Кадрды беру мүмкін болмады. Жұмысты «Тарих» бөлімінде ашып, қайта көріңіз.",
    "образ": "образ",
    "образа": "образ",
    "образах": "образда",
    "образе": "образда",
    "образов": "образ",
    "Образы": "Образдар",
    "Образы сняты": "Образдар түсірілді",
    "Поиск образов": "Образдарды іздеу",
    "Полароид-рилс": "Полароид-рилс",
    "Предыдущий": "Алдыңғы",
    "Пример кадра · {0} из {1}": "Кадр мысалы · {1} ішінен {0}",
    "Скачать все": "Барлығын жүктеп алу",
    "Следующий": "Келесі",
    "Смотреть все кадры": "Барлық кадрларды көру",
    "Смотреть кадры: {0}": "Кадрларды көру: {0}",
    "Снимаем образы": "Образдарды түсіріп жатырмыз",
    "Создаём фотосессию": "Фотосессия жасалуда",
    "Создать {0} · {1} C": "{0} жасау · {1} C",
    "Создать фотосессию": "Фотосессия жасау",
    "Удерживайте, чтобы посмотреть кадры": "Кадрларды көру үшін басып тұрыңыз",
    "фото не созданы": "фотосуреттер жасалмады",
    "Фото проверены": "Фотосуреттер тексерілді",
    "Фотосессия готова": "Фотосессия дайын",
    "Фотосессия не прошла проверку": "Фотосессия тексеруден өтпеді",
    "Добавьте в кадр себя, близкого или персонажа": "Кадрға өзіңізді, жақыныңызды немесе кейіпкерді қосыңыз"
  },
  "uk": {
    "· всё входит": "· усе входить",
    "{0} · {1} из {2}": "{0} · {1} із {2}",
    "{0} · кадр {1} из {2}": "{0} · кадр {1} із {2}",
    "{0} · пример · {1} из {2}": "{0} · приклад · {1} із {2}",
    "{0} в {1}": "{0} в {1}",
    "{0}: кадры образа": "{0}: кадри образу",
    "{0}: пример крупно": "{0}: приклад крупно",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}. Бот надішле їх у чат, в окрему тему.",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}. Бот уже надіслав їх у чат, в окрему тему.",
    "Все образы": "Усі образи",
    "Все образы, {0}": "Усі образи, {0}",
    "выберите образ": "виберіть образ",
    "Выберите хотя бы один образ": "Виберіть хоча б один образ",
    "Выбранные · {0}": "Вибрані · {0}",
    "Выбрать образ": "Вибрати образ",
    "Готово · {0} · {1}": "Готово · {0} · {1}",
    "Ещё образ": "Ще образ",
    "за кадр": "за кадр",
    "Загружаем образы…": "Завантажуємо образи…",
    "Изменить настройки": "Змінити налаштування",
    "Искать среди {0} образов": "Шукати серед {0} образів",
    "кадр": "кадр",
    "Кадр {0}": "Кадр {0}",
    "кадр {0} из {1}": "кадр {0} із {1}",
    "кадра": "кадри",
    "кадров": "кадрів",
    "Кадры": "Кадри",
    "Кадры ещё загружаются": "Кадри ще завантажуються",
    "Кадры фотосессии": "Кадри фотосесії",
    "Как будет выглядеть": "Як це виглядатиме",
    "Модерация после списания": "Модерація після списання",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "Можна піти з екрана: бот надішле фото в чат у міру готовності.",
    "Нажмите, чтобы выбрать образ": "Натисніть, щоб вибрати образ",
    "Например: нарядная одежда, без очков": "Наприклад: святковий одяг, без окулярів",
    "Не получилось снять фотосессию": "Не вдалося створити фотосесію",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "Не вдалося передати кадр. Відкрийте роботу в «Історії» і спробуйте ще раз.",
    "образ": "образ",
    "образа": "образи",
    "образах": "образах",
    "образе": "образі",
    "образов": "образів",
    "Образы": "Образи",
    "Образы сняты": "Образи знято",
    "Поиск образов": "Пошук образів",
    "Полароид-рилс": "Полароїд-рилс",
    "Предыдущий": "Попередній",
    "Пример кадра · {0} из {1}": "Приклад кадру · {0} із {1}",
    "Скачать все": "Завантажити всі",
    "Следующий": "Наступний",
    "Смотреть все кадры": "Переглянути всі кадри",
    "Смотреть кадры: {0}": "Переглянути кадри: {0}",
    "Снимаем образы": "Знімаємо образи",
    "Создаём фотосессию": "Створюємо фотосесію",
    "Создать {0} · {1} C": "Створити {0} · {1} C",
    "Создать фотосессию": "Створити фотосесію",
    "Удерживайте, чтобы посмотреть кадры": "Утримуйте, щоб переглянути кадри",
    "фото не созданы": "фото не створено",
    "Фото проверены": "Фото перевірено",
    "Фотосессия готова": "Фотосесія готова",
    "Фотосессия не прошла проверку": "Фотосесія не пройшла перевірку",
    "Добавьте в кадр себя, близкого или персонажа": "Додайте в кадр себе, близьку людину або персонажа"
  },
  "zh": {
    "· всё входит": "· 全部包含",
    "{0} · {1} из {2}": "{0} · {1} / {2}",
    "{0} · кадр {1} из {2}": "{0} · 画面 {1} / {2}",
    "{0} · пример · {1} из {2}": "{0} · 示例 · {1} / {2}",
    "{0} в {1}": "{0} 用于 {1}",
    "{0}: кадры образа": "{0}：造型画面",
    "{0}: пример крупно": "{0}：示例大图",
    "{0}. Бот пришлёт их в чат, в отдельную тему.": "{0}。机器人会把它们发到聊天的单独话题中。",
    "{0}. Бот уже прислал их в чат, в отдельную тему.": "{0}。机器人已把它们发到聊天的单独话题中。",
    "Все образы": "全部造型",
    "Все образы, {0}": "全部造型，{0}",
    "выберите образ": "选择造型",
    "Выберите хотя бы один образ": "请至少选择一个造型",
    "Выбранные · {0}": "已选 · {0}",
    "Выбрать образ": "选择造型",
    "Готово · {0} · {1}": "完成 · {0} · {1}",
    "Ещё образ": "再加一个造型",
    "за кадр": "每个画面",
    "Загружаем образы…": "正在加载造型…",
    "Изменить настройки": "修改设置",
    "Искать среди {0} образов": "在 {0} 个造型中搜索",
    "кадр": "画面",
    "Кадр {0}": "画面 {0}",
    "кадр {0} из {1}": "画面 {0} / {1}",
    "кадра": "画面",
    "кадров": "画面",
    "Кадры": "镜头",
    "Кадры ещё загружаются": "画面仍在加载",
    "Кадры фотосессии": "写真画面",
    "Как будет выглядеть": "效果预览",
    "Модерация после списания": "扣费后审核",
    "Можно уйти с экрана: бот пришлёт фото в чат по мере готовности.": "可以离开此页面：照片完成后机器人会陆续发到聊天中。",
    "Нажмите, чтобы выбрать образ": "点击选择造型",
    "Например: нарядная одежда, без очков": "例如：盛装，不戴眼镜",
    "Не получилось снять фотосессию": "写真生成失败",
    "Не удалось передать кадр. Откройте работу в «Истории» и попробуйте снова.": "无法传递画面。请在「历史」中打开作品后重试。",
    "образ": "造型",
    "образа": "造型",
    "образах": "造型",
    "образе": "造型",
    "образов": "造型",
    "Образы": "造型",
    "Образы сняты": "造型已拍完",
    "Поиск образов": "搜索造型",
    "Полароид-рилс": "拍立得 Reels",
    "Предыдущий": "上一个",
    "Пример кадра · {0} из {1}": "示例画面 · {0} / {1}",
    "Скачать все": "全部下载",
    "Следующий": "下一个",
    "Смотреть все кадры": "查看全部画面",
    "Смотреть кадры: {0}": "查看画面：{0}",
    "Снимаем образы": "正在拍摄造型",
    "Создаём фотосессию": "正在创建写真",
    "Создать {0} · {1} C": "创建{0} · {1} C",
    "Создать фотосессию": "创建写真",
    "Удерживайте, чтобы посмотреть кадры": "长按查看画面",
    "фото не созданы": "照片未生成",
    "Фото проверены": "照片已检查",
    "Фотосессия готова": "写真已完成",
    "Фотосессия не прошла проверку": "写真未通过审核",
    "Добавьте в кадр себя, близкого или персонажа": "请把你自己、亲友或角色加入画面"
  }
}
